import ReactTable from "react-table";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  CardTitle,
  UncontrolledButtonDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Form,
} from "reactstrap";
import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
// import "../../../RegistrationJourney/Components/ProgressBar.css";

import { SetInnerHtmlWithClassReplacement } from "../../../../../../../Utils/Constants";

import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LoadingOverlay from "react-loading-overlay";
import Loader from "react-loaders";
import PCArchiveIcon from '../../../../../../../designUtils/Storeoverview/PartnerLogs/PCArchiveIcon.svg'

import PMUpdateTicketAgeDaysService from "../../../../../../../Service/OPSServices/ProactiveMonitoringServices/PMUpdateTicketAgeDaysService";
import PMPartnerViewTicket from "./Components/PMPartnerViewTicket";
import PMSWViewTicket from "./Components/PMSWViewTicket";
import PMAgencyViewTicket from "./Components/PMAgencyViewTicket";
import PMArchivedTicketListPage from "./PMArchivedTicketListPage";
import PMBulkArchiveTicketService from "../../../../../../../Service/OPSServices/ProactiveMonitoringServices/PMBulkArchiveTicketService";
import CustomModal from "../../../../../../Components/Modals/CustomModal";
import PMGetAllTicketsDataService from "../../../../../../../Service/OPSServices/ProactiveMonitoringServices/PMGetAllTicketsDataService";
import PMSmartDataFormatter from "../PMDashboard/PMTasks/PMSubComponentsSwTeamTask/PMSmartDataFormatter";
function ProactiveTicketMainPage(props) {
  const [mainRequestTypes, setMainRequestTypes] = useState();
  const [mainRequestTypeTitle, setMainRequestTypeTitle] = useState("");
  const [problemAreaList, setProblemAreaList] = useState();
  const [problemAreaPathwayList, setProblemAreaPathwayList] = useState();
  const [statusColorDecription, setStatusColorDecription] = useState([]);
  const [subRequestTypes, setSubRequestTypes] = useState();
  const [ticketList, setTicketList] = useState([]);
  const [ticketViewData, setTicketViewData] = useState();
  const [ticketId, setTicketId] = useState();
  const [storeIdForViewTicket, setStoreIdForViewTicket] = useState();
  const [storeNameForViewTicket, setStoreNameForViewTicket] = useState();
  const [ticketStatuslistCount, setTicketStatuslistCount] = useState();
  // const [notAssignedCount, setNotAssignedCount] = useState();
  const [notAcceptedCount, setNotAcceptedCount] = useState();
  const [problemArea, setProblemArea] = useState()
  const [problemAreaPathway, setProblemAreaPathway] = useState()
  const [permissions, setpermissions] = useState()
  const [archivedTicket, setArchivedTicket] = useState(false)
  const [selectTicketId, setSelectTicketId] = useState([])

  const [
    storeDateTimeForViewTicket,
    setStoreDateTimeForViewTicket,
  ] = useState();
  const [ticketStatuslist, setTicketStatuslist] = useState();
  const [teamMembers, setTeamMembers] = useState();
  // storeOverview
  const [isViewTicketOpen, setIsViewTicketOpen] = useState(false);
  const [isSWViewTicketOpen, setIsSWViewTicketOpen] = useState(false);
  const [isAgencyTicketPopup, setIsAgencyTicketPopup] = useState(false);
  const [query, setQuery] = useState('');
  const [internalQuery, setInternalQuery] = useState("");
  const [searchStore, setSearchStore] = useState("");
  const [statusFilter, setStatusFilter] = useState("Open");
  const [assignedToFilter, setAssignedToFilter] = useState(false);
  const [assignedToFilterValue, setAssignedToFilterValue] = useState(false);
  const [issueDescriptionText, setIssueDescriptionText] = useState("");

  // store list dropdown
  const [storeIntegerId, setStoreIntegerId] = useState("");
  const [store, setStore] = useState("");
  const [showTicketList, setShowTicketList] = useState(false);
  const [issueDescription, setIssueDescription] = useState(false);
  const [showAsin, setShowAsin] = useState(false);
  const [allAsinList, setAllAsinList] = useState([]);
  const [ticketAgeDays, setTicketAgeDays] = useState('');
  const [ticketAgeId, setTicketAgeId] = useState('');
  const [ticketAgeDaysIsOpen, setTicketAgeDaysIsOpen] = useState(false);
  const [ticketAgeDaysColor, setTicketAgeDaysColor] = useState('');
  const [isInternalTicketCheck, setIsInternalTicketCheck] = useState(false);
  const [amazonCaseId, setAmazonCaseId] = useState();
  const [amazonCaseUrl, setAmazonCaseUrl] = useState();
  const [createrPriority, setCreaterPriority] = useState('');
  const [archiveFlag, setArchiveFlag] = useState(false)
  const [archivedTicketCounts, setArchivedTicketCounts] = useState('0')
  const [isCriticalPriorityCheck, setIsCriticalPriorityCheck] = useState(false);
  const [criticalQuery, setCriticalQuery] = useState('');

  const filteredTicketList = ticketList.filter((row) => {
    const lowerQuery = query.toLowerCase();
    const lowerInternalQuery = internalQuery.toLowerCase();
    const lowerCriticalQuery = criticalQuery.toLowerCase();

    const storeName = (row.storeName || '').toLowerCase();
    const problemArea = (row.problemArea || '').toLowerCase();
    const problemAreaPathway = (row.problemAreaPathway || '').toLowerCase();
    const requestSubTypes = (row.requestSubTypes || '').toLowerCase();
    const ticketStatus = (row.ticketStatus || '').toLowerCase();
    const createrPriority = (row.createrPriority || '').toLowerCase();
    const issueDescription = (row.issueDescription || '').toLowerCase();
    const priority = (row.priority || '').toLowerCase();
    const createdBy = (row.ticketCreateBy || '').toLowerCase();
    const ticketId = row.ticketId ? row.ticketId.toString().toLowerCase() : '';
    const firstAsin = row.firstAsin ? row.firstAsin.toString().toLowerCase() : '';
    const assignedTo = (row.assignedTo || '').toLowerCase();

    let queryMatch = true;
    if (query !== '') {
      queryMatch =
        storeName.includes(lowerQuery) ||
        problemArea.includes(lowerQuery) ||
        problemAreaPathway.includes(lowerQuery) ||
        requestSubTypes.includes(lowerQuery) ||
        ticketStatus.includes(lowerQuery) ||
        createrPriority.includes(lowerQuery) ||
        issueDescription.includes(lowerQuery) ||
        priority.includes(lowerQuery) ||
        createdBy.includes(lowerQuery) ||
        ticketId.includes(lowerQuery) ||
        firstAsin.includes(lowerQuery);
    }

    const internalTicket = priority.includes(lowerInternalQuery);
    const criticalTicket = priority.includes(lowerCriticalQuery) || createrPriority.includes(lowerCriticalQuery);

    const internalMatch = internalQuery !== '' ? internalTicket : true;
    const criticalMatch = criticalQuery !== '' ? criticalTicket : true;

    let assignedToMatch = true;
    if (assignedToFilterValue && assignedToFilterValue.trim() !== '') {
      const words = assignedToFilterValue.trim().split(' ');
      words.pop();
      const resultString = words.join(' ').toLowerCase();
      assignedToMatch = assignedTo.includes(resultString);
    }

    let statusMatch = true;
    if (statusFilter !== 'All') {
      if (statusFilter === 'Open') {
        statusMatch = ticketStatus !== 'closed' && ticketStatus !== 'resolved' && ticketStatus !== 'abandoned';
      } else {
        statusMatch = ticketStatus === statusFilter.toLowerCase();
      }
    }

    let combinedQuery;
    if (internalQuery !== '' || criticalQuery !== '') {
      combinedQuery =
        queryMatch &&
        (internalQuery !== '' ? internalTicket : true) &&
        (criticalQuery !== '' ? criticalTicket : true);
    } else {
      combinedQuery = queryMatch;
    }

    return combinedQuery && internalMatch && criticalMatch && assignedToMatch && statusMatch;
  });


  const fetchFilteredTickets = async (IntegerId) => {
    let myWorkStatus = props.isMyworksScreen ? 'dashboardData' : '';
    
    let data = {
      integerId: IntegerId,
      myDash: myWorkStatus
    };
    const response = await PMGetAllTicketsDataService(props.token, data);
    if (response) {
      console.log("OPSGetAllTicketsDataService back");
      console.log(response);
      setArchivedTicketCounts(response.ArchivedTicketCount)
      console.log(response.ticketList[0]);
      // console.log(response.ticketList[0].problemArea);

      setTicketList(response.ticketList);
      setTicketStatuslistCount(response.StatusCount.status_list);
      // setNotAssignedCount(response.StatusCount.notAssigned);
      setNotAcceptedCount(response.StatusCount.notAccepted);
      setTicketViewData(response.ticketHistory);
      setMainRequestTypes(response.mainRequestTypes);
      response.mainRequestTypes.map((type) => {
        if (props.requestTypeID == type.id) {
          setMainRequestTypeTitle(type.requestType);
        }
      });
      setTeamMembers(response.teamMembers);
      setProblemAreaList(response.problemAreaList);
      setProblemAreaPathwayList(response.problemAreaPathwayList);
      setStatusColorDecription(response.statusColorDecription);
      setSubRequestTypes(response.subRequestTypes);

      setTicketStatuslist(response.ticketStatuslist);
      setShowTicketList(true);
    }
  };
  useEffect(() => {
    fetchFilteredTickets(0);
  }, []);
  const updateArchivedTicket = () => {
    setArchiveFlag(true)
    let myWorkStatus = ''
    let data = {
      myDash: myWorkStatus,
      id: selectTicketId
    }
    PMBulkArchiveTicketService(props.token, data).then((res) => {
      if (res) {
        console.log(res.ticketList);
        setTicketList(res.ticketList);
        setArchivedTicketCounts(res.ArchivedTicketCount)
        setTicketStatuslistCount(res.StatusCount.status_list);
        // setNotAssignedCount(res.StatusCount.notAssigned);
        setNotAcceptedCount(res.StatusCount.notAccepted);
        setTicketViewData(res.ticketHistory);
        setMainRequestTypes(res.mainRequestTypes);
        setArchiveFlag(false)
        setSelectTicketId([])

      }
    })
  }
  const handleSelectArchivedTicket = (id) => {
    setSelectTicketId((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleCreateAndViewTicketClose = (response) => {
    console.log(response);
    setTicketList(response.ticketList);
    setMainRequestTypes(response.mainRequestTypes);
    setSubRequestTypes(response.subRequestTypes);
    setTicketViewData(response.ticketHistory);
    setTicketStatuslistCount(response.StatusCount.status_list);
    // setNotAssignedCount(response.StatusCount.notAssigned);
    setNotAcceptedCount(response.StatusCount.notAccepted);
    setTicketStatuslist(response.ticketStatuslist);
    setIsViewTicketOpen(false);
    setIsSWViewTicketOpen(false);
    setpermissions()
  };
  const handleAmazonCasePopup = (response) => {
    console.log(response);
    setTicketList(response.ticketList);
    setMainRequestTypes(response.mainRequestTypes);
    setSubRequestTypes(response.subRequestTypes);
    setTicketViewData(response.ticketHistory);
    setTicketStatuslistCount(response.StatusCount.status_list);
    // setNotAssignedCount(response.StatusCount.notAssigned);
    setNotAcceptedCount(response.StatusCount.notAccepted);
    setTicketStatuslist(response.ticketStatuslist);
  };
  const handleViewTicket = (
    ticketId,
    problemArea,
    problemAreaPathway,
    mainType,
    integerId,
    storeName,
    amazonCaseId,
    amazonCaseUrl,
    datetime,
    permissions
  ) => {
    setAmazonCaseId(amazonCaseId > 0 ? amazonCaseId : '')
    setAmazonCaseUrl(amazonCaseUrl ? amazonCaseUrl : '#')
    setTicketId(ticketId);
    setProblemArea(problemArea)
    setProblemAreaPathway(problemAreaPathway)
    setStoreIdForViewTicket(integerId);
    setStoreNameForViewTicket(storeName);
    setStoreDateTimeForViewTicket(datetime);
    setMainRequestTypeTitle(mainType);
    setIsViewTicketOpen(true);
    setpermissions(permissions)
  };
  const handleSWViewTicket = (
    ticketId,
    createrPriority,
    problemArea,
    problemAreaPathway,
    mainType,
    integerId,
    storeName,
    amazonCaseId,
    amazonCaseUrl,
    datetime,
    permissions
  ) => {
    setAmazonCaseId(amazonCaseId > 0 ? amazonCaseId : '')
    setAmazonCaseUrl(amazonCaseUrl ? amazonCaseUrl : '#')
    setTicketId(ticketId);
    setProblemArea(problemArea)
    setProblemAreaPathway(problemAreaPathway)
    setStoreIdForViewTicket(integerId);
    setStoreDateTimeForViewTicket(datetime);
    setStoreNameForViewTicket(storeName);
    setMainRequestTypeTitle(mainType);
    setCreaterPriority(createrPriority);
    setIsSWViewTicketOpen(true);
    setpermissions(permissions)
  };
  const handleAgencyTicket = (
    ticketId,
    problemArea,
    problemAreaPathway,
    mainType,
    integerId,
    storeName,
    amazonCaseId,
    amazonCaseUrl,
    datetime,
    permissions
  ) => {
    setAmazonCaseId(amazonCaseId > 0 ? amazonCaseId : '')
    setAmazonCaseUrl(amazonCaseUrl ? amazonCaseUrl : '#')
    setTicketId(ticketId);
    setProblemArea(problemArea)
    setProblemAreaPathway(problemAreaPathway)
    setStoreIdForViewTicket(integerId);
    setStoreNameForViewTicket(storeName);
    setStoreDateTimeForViewTicket(datetime);
    setMainRequestTypeTitle(mainType);
    setIsAgencyTicketPopup(true);
    setpermissions(permissions)
  };
  const filterDropDownActions = [
    {
      id: 1,
      text: 'SW Tickets Management',
      value: props.globalPermissions ? props.globalPermissions.SWTicketList_SWInternalCommunication : false,
    },
    {
      id: 2,
      text: 'Partner Communication',
      value: props.globalPermissions ? props.globalPermissions.SWTicketList_PartnerCommunication : false,
    },
    {
      id: 3,
      text: 'Agency Communication',
      value: props.globalPermissions ? props.globalPermissions.SWTicketList_AgencyInternalCommunication : false,
    },
  ]
  const quickActions = [
    {
      name: () => "SW Tickets Management",
      action: ({
        ticketId,
        createrPriority,
        problemArea,
        problemAreaPathway,
        storeName,
        requestType,
        integerId,
        amazonCaseId,
        amazonCaseUrl,
        ticketCreatedAt,
        permissions
      }) => {
        handleSWViewTicket(
          ticketId,
          createrPriority,
          problemArea,
          problemAreaPathway,
          requestType,
          integerId,
          storeName,
          amazonCaseId,
          amazonCaseUrl,
          ticketCreatedAt,
          permissions
        );
      },
    },
    {
      name: () => "Agency Communication",
      action: ({
        ticketId,
        problemArea,
        problemAreaPathway,
        requestType,
        integerId,
        storeName,
        amazonCaseId,
        amazonCaseUrl,
        ticketCreatedAt,
        permissions
      }) => {
        handleAgencyTicket(
          ticketId,
          problemArea,
          problemAreaPathway,
          requestType,
          integerId,
          storeName,
          amazonCaseId,
          amazonCaseUrl,
          ticketCreatedAt,
          permissions
        );
      },
    },
    {
      name: () => "Partner Communication",
      action: ({
        ticketId,
        problemArea,
        problemAreaPathway,
        requestType,
        integerId,
        storeName,
        amazonCaseId,
        amazonCaseUrl,
        ticketCreatedAt,
        permissions
      }) => {
        handleViewTicket(
          ticketId,
          problemArea,
          problemAreaPathway,
          requestType,
          integerId,
          storeName,
          amazonCaseId,
          amazonCaseUrl,
          ticketCreatedAt,
          permissions
        );
      },
    },

  ];
  const quickActions1 = [
    {
      name: () => "SW Tickets Management",
      action: ({
        ticketId,
        createrPriority,
        problemArea,
        problemAreaPathway,
        requestType,
        integerId,
        storeName,
        amazonCaseId,
        amazonCaseUrl,
        ticketCreatedAt,
        permissions
      }) => {
        handleSWViewTicket(
          ticketId,
          createrPriority,
          problemArea,
          problemAreaPathway,
          requestType,
          integerId,
          storeName,
          amazonCaseId,
          amazonCaseUrl,
          ticketCreatedAt,
          permissions
        );
      },
    },
    {
      name: () => "Agency Communication",
      action: ({
        ticketId,
        problemArea,
        problemAreaPathway,
        requestType,
        integerId,
        storeName,
        amazonCaseId,
        amazonCaseUrl,
        ticketCreatedAt,
        permissions
      }) => {
        handleAgencyTicket(
          ticketId,
          problemArea,
          problemAreaPathway,
          requestType,
          integerId,
          storeName,
          amazonCaseId,
          amazonCaseUrl,
          ticketCreatedAt,
          permissions
        );
      },
    },
  ];
  const quickActionsDropdown = (actions, id) => (
    <UncontrolledButtonDropdown>
      <DropdownToggle caret color="link" style={{ textDecoration: 'underline' }}>
        {id}
      </DropdownToggle>
      <DropdownMenu>
        {quickActions.map((qa) => {
          const isActionAllowed = filterDropDownActions.some(
            (match) => match.text === qa.name(actions) && match.value === true
          );

          return (
            isActionAllowed && (
              <DropdownItem key={qa.name(actions)} onClick={() => qa.action(actions)}>
                {qa.name(actions)}
              </DropdownItem>
            )
          );
        })}
      </DropdownMenu>
    </UncontrolledButtonDropdown>
  );

  const quickActionsDropdown1 = (actions, id) => (
    <UncontrolledButtonDropdown>
      <DropdownToggle caret color="link" style={{ textDecoration: 'underline' }}>
        {id}
      </DropdownToggle>
      <DropdownMenu>
        {quickActions1.map((qa) => {
          const isActionAllowed = filterDropDownActions.some(
            (match) => match.text === qa.name(actions) && match.value === true
          );

          return (
            isActionAllowed && (
              <DropdownItem key={qa.name(actions)} onClick={() => qa.action(actions)}>
                {qa.name(actions)}
              </DropdownItem>
            )
          );
        })}
        {/* {quickActions1.map((qa) => (
          <DropdownItem key={qa.name} onClick={() => qa.action(actions)}>
            {qa.name(actions)}
          </DropdownItem>
        ))} */}
      </DropdownMenu>
    </UncontrolledButtonDropdown>
  );
  const viewIssueDescription = (text) => {
    setIssueDescription(true);
    setIssueDescriptionText(text);
  };
  const ViewTicketAgeDiscription = (id, text, color) => {
    setTicketAgeId(id)
    setTicketAgeDays(text)
    setTicketAgeDaysColor(color)
    setTicketAgeDaysIsOpen(true)
  }
  const stripHtmlTags = (html) => {
    if (!html) return '';
    return html.replace(/<[^>]*>/g, '');
  };
  const columns = [

    {
      Header: "ID",
      accessor: "ticketId",
      width: 65,
      Cell: (props) => {
        return (
          <>

            {props.original.ticketStatus == 'Closed' &&
              <input
                type='checkbox'
                title="Archive"
                checked={selectTicketId.includes(props.value)}
                onClick={() => handleSelectArchivedTicket(props.value)}
              />
            }
            {props.original.isInternalTicket ?
              quickActionsDropdown1(props.original, props.value) :
              quickActionsDropdown(props.original, props.value)}

          </>
        );
      },
    },
    {
      Header: "Internal Priority",
      accessor: "priority",
      width: 80,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          {/* <p className="m-0">
            {cellInfo.value === "Urgent" ? (
              <img src={Urgent} alt="not found" />
            ) : (
              cellInfo.value
            )}
          </p> */}
          <p><b>{cellInfo.value}</b></p>
        </div>
      ),
    },
    {
      Header: "Creator Priority",
      accessor: "createrPriority",
      width: 80,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          {/* <p className="m-0">
            {cellInfo.value === "Urgent" ? (
              <img src={Urgent} alt="not found" />
            ) : (
              cellInfo.value
            )}
          </p> */}
          <p><b>{cellInfo.value}</b></p>
        </div>
      ),
    },
    {
      Header: "Date",
      accessor: "ticketOriginaldate",
      width: 100,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="m-0"><b>{cellInfo.original.ticketCreatedAt}</b></p>
        </div>
      ),
    },
    {
      Header: "Last Updated",
      accessor: "lastModified",
      width: 100,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="m-0"><b>{cellInfo.original.lastModified}</b></p>
        </div>
      ),
    },
    {
      Header: "Updated By",
      width: 100,
      accessor: "ticketUpdatedBy",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <span>
            <b>{cellInfo.value}</b>
          </span>
        </div>
      ),
    },
    {
      Header: "Store Name",
      width: 120,
      accessor: "storeName",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="m-0"><b>{cellInfo.value}</b></p>
        </div>
      ),
    },
    {
      Header: "Asin",
      width: 120,
      accessor: "firstAsin",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          {/* <p className="m-0" onClick={()=>showAsinList(cellInfo.original.asinList)}><b>{cellInfo.value}</b></p> */}
          <p
            className="m-0 comment-paragraph"
            style={{ color: "#3D85C6", cursor: "pointer" }}
            onClick={() => showAsinList(cellInfo.value)}
          >
            <b>{cellInfo.value}</b>
          </p>
        </div>
      ),
    },
    {
      Header: "Issue",
      accessor: "issueDescription",
      width: 120,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p
            className="m-0 comment-paragraph"
            style={{ color: "#3D85C6", cursor: "pointer" }}
            onClick={() =>
              viewIssueDescription(
                cellInfo.value,
                cellInfo.original.issueDescription
              )
            }
          >
            <b>{stripHtmlTags(cellInfo.value)}</b>
          </p>
        </div>
      ),
    },
    {
      Header: "Status",
      accessor: "ticketStatus",
      width: 85,
      Cell: (cellInfo) => (
        <div className="d-flex  w-100">
          <span>
            <b>{cellInfo.value}</b>
          </span>
        </div>
      ),
    },
    {
      Header: "Created By",
      width: 100,
      accessor: "ticketCreateBy",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <span>
            <b>{cellInfo.value}</b>
          </span>
        </div>
      ),
    },
    {
      Header: "Assigned To",
      width: 100,
      accessor: "assignedTo",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <span>
            <b>{cellInfo.value}</b>
          </span>
        </div>
      ),
    },
    {
      Header: " Problem Area",
      width: 90,
      accessor: "problemArea",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="m-0"><b>{cellInfo.value}</b></p>
        </div>
      ),
    },
    {
      Header: "Pathway",
      accessor: "problemAreaPathway",
      width: 120,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="m-0"><b>{cellInfo.value}</b></p>
        </div>
      ),
    },
    {
      Header: "Sub Request ",
      width: 150,
      accessor: "requestSubTypes",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="m-0"><b>{cellInfo.value}</b></p>
        </div>
      ),
    },
    // {
    //   Header: "Actions",
    //   width: 75,
    //   Cell: (props) => (<>{props.original.isInternalTicket ? quickActionsDropdown1(props.original) : quickActionsDropdown(props.original)} </>),
    // },

  ];
  const filteredColumns = props.accessLevel === 3
    ? columns.filter(col => col.accessor !== "priority" && col.accessor !== "assignedTo")
    : columns;

  const showAsinList = (asinlist) => {
    const asinArray = asinlist.split(',');
    setAllAsinList(asinArray)
    setShowAsin(true)
  }
  const newFilter = (e) => {
    if (e.target.checked) {
      setIsInternalTicketCheck(e.target.checked);
      setInternalQuery(e.target.checked ? 'internal' : '');
    }
    else {
      setInternalQuery('');
      setIsInternalTicketCheck(e.target.checked);
    }
  }

  const getRowProps = (state, rowInfo) => {
    if (rowInfo && rowInfo.original) {
      return {
        style: {
          background:
            rowInfo.original.priority === "Onboarding Task" ? ''
              : rowInfo.original.ticketStatus === "Closed" ? "#cccccc"
                : rowInfo.original.priority === "Internal Ticket" ? " "

                  : rowInfo.original.bgColor,
          color:
            rowInfo.original.ticketStatus === "Closed"
              ? "#000"
              : rowInfo.original.bgColor
                ? "#000"
                : "#000",
          fontWeight: 300

        },
      };
    }
    return {};
  };

  const handleCriticalFilter = (e) => {
    setIsCriticalPriorityCheck(e.target.checked);
    setCriticalQuery(e.target.checked ? 'critical' : ''); // set meaningful value
  };


  const UpdateTicketAgeDays = (id) => {

    if (id) {
      const data = {
        id: id,
        ticketAgeDays: ticketAgeDays
      }
      PMUpdateTicketAgeDaysService(props.token, data).then((response) => {
        if (response) {
          console.log(response);
          setTicketAgeDays(data['ticketAgeDays'])
          setStatusColorDecription(response.statusColorDecription);
          setTicketAgeDaysIsOpen(false)
          window.location.reload();
        }
      });
    }
  }
  const ticketAgeColor = {
    1: '#ffce04',
    2: '#ffc38b',
    3: '#ff8080',

  }
  const replaceIssueDescriptionText = SetInnerHtmlWithClassReplacement(issueDescriptionText);

  return (
    <section className="">
      <Container fluid className="p-0">
        <Row className="m-0">
          {/*  <Col md={12} className="p-0">
            <Card className="main-card mb-3 mt-3">
            <CardBody>
              <Row md="12">
               <Col md="2 ">
                <CardTitle className='mt-2' style={{ fontSize: '15px' }}>Tickets</CardTitle>
                </Col> 
                <Col md={5 }>
                  <DropdownList
                    data={props.stores}
                    dataKey="id"
                    textField="name"
                    placeholder="Select Store"
                    value={store}
                    onChange={(value) => {
                      setStoreInteger(value);
                    }}
                  />
                 </Col>
                 <Col md={7}>
                  <LoadingButton
                    className="button-ticket ml-4"
                    onClick={getTicketsData}
                  >
                    Fetch Tickets 
                  </LoadingButton>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>*/}
        {!props.isMyworksScreen && (
          <Col md={12} className={'p-0'}>
            <Card className="main-card  mb-3 mt-5 ml-3 mr-3">
              <CardBody>
                <Row>
                  <Col md="12">
                    <CardTitle className={props.accessLevel != 0 ? 'mt-5 border mb-0 p-2 text-center' : 'mt-2 border mb-0 p-2 text-center'} style={{ fontSize: '20px', color: '#243837', backgroundColor: '#B1FA63' }}>Ticket Status</CardTitle>
                    <div className="d-flex border p-1 justify-content-around">
                      {
                        ticketStatuslistCount ?
                          ticketStatuslistCount.map((item) => (

                            <>
                              {item.status === 'Assigned' ? <div key={item.status} className="border pt-2 pb-2 pl-2 pr-2 m-1">
                                <div className="d-flex justify-content-center">
                                  <h5 className="text-center" style={{ color: item.color }}>
                                    <b>{item.count}</b>
                                  </h5> &nbsp;
                                  <h5 className="text-center mb-0" style={{ color: item.color }}>
                                    <b>{item.status}</b>
                                  </h5>

                                </div>
                                <div>
                                  <h5 className="mb-0 mt-2" style={{ color: ' #52007B' }}><b>{notAcceptedCount} Not Accepted</b></h5>
                                </div>

                              </div> :
                                <div key={item.status} className="border pt-2 pb-2 pl-2 pr-2 m-1">
                                  <h4 className="text-center" style={{ color: item.color }}>
                                    <b>{item.count}</b>
                                  </h4>
                                  <h5 className="text-center" style={{ color: item.color }}>
                                    <b>{item.status}</b>
                                  </h5>

                                </div>
                              }
                            </>

                          ))
                          :
                          <p>Loading Ticket Statistics...</p>
                      }

                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          )}

          <Col md={12} className={`d-flex ${props.isMyworksScreen ? 'mt-3' : ''}`}>
            <h6
              className={`mr-3 ${archivedTicket === false ? 'selected-tickets' : 'not-seletcted-tickets'}`}
              onClick={() => setArchivedTicket(false)}><b className="">Work In Progress</b></h6>
            
            {!props.isMyworksScreen && (
              <h6
              className={`mr-3 ${archivedTicket === true ? 'selected-tickets' : 'not-seletcted-tickets'}`}
              onClick={() => setArchivedTicket(true)}><b>Archived {' (' + archivedTicketCounts + ')'}</b></h6>
            )} 
            <h6 className="mt-2">
              <img title="Archive" style={{ cursor: selectTicketId.length > 0 && !archiveFlag ? 'pointer' : 'not-allowed', opacity: selectTicketId.length > 0 && !archiveFlag ? 1 : 0.5 }}
                onClick={selectTicketId.length > 0 && !archiveFlag ? updateArchivedTicket : undefined} src={PCArchiveIcon} />
            </h6>
           
          </Col>


          {showTicketList && (props.globalPermissions ? props.globalPermissions.SWTicketList_List : false) ?
            (<Col md="12" className="mbg-3 p-0">
              <Card className="main-card mb-3 mt-3">
                <CardBody>

                  {archivedTicket ?
                    <PMArchivedTicketListPage
                    /> :

                    <>
                      <Row>
                        <Col md={7}>
                          <p><b>TICKET LIST</b></p>
                          <div className="row">
                            <Col md={4}>
                              <label>
                                <input
                                  type="text"
                                  placeholder="Search Text"
                                  value={query}
                                  className="search form-control "
                                  onChange={(e) => {
                                    setQuery(e.target.value);
                                    setAssignedToFilter(true)
                                  }}
                                />
                              </label>
                            </Col>
                            
                            {!props.isMyworksScreen && props.accessLevel === 0 && (
                            <Col md={5}>
                              <select
                                id="assignedTo"
                                name="assignedTo"
                                onChange={(e) => {
                                  setAssignedToFilterValue(e.target.value);
                                  setAssignedToFilter(true)
                                }}
                                value={assignedToFilterValue ? assignedToFilterValue : ''}
                                className="form-control "
                              >
                                <option value="">-- Assigned To --</option>
                                {teamMembers
                                  ? teamMembers.map((member) => (
                                    <option value={member.employeeName} title={`${member.note}`}>
                                      {member.employeeName}
                                    </option>
                                  ))
                                  : ""}
                              </select>

                            </Col>
                            )}
                            <Col md={3} className="mt-2">
                              <div className="internal-critical-checkbox">
                                <label className="internal-ticket-checkbox">
                                  <input
                                    value={internalQuery}
                                    type="checkbox"
                                    checked={isInternalTicketCheck}
                                    onChange={(e) => newFilter(e)}
                                  />
                                  <b>Internal</b>
                                </label>
                                <label className="critical-ticket-checkbox">
                                  <input
                                    type="checkbox"
                                    checked={isCriticalPriorityCheck}
                                    onChange={(e) => handleCriticalFilter(e)}
                                  />
                                  <b>Critical</b>
                                </label>
                              </div>
                            </Col>

                          </div>
                        </Col>
                       
                          <>
                            {/* {props.notificationsDetails.action == true && props.notificationsDetails.action != undefined ?
                              <Card className="notification-card p-3 mb-2 card-of-problemarea">
                                <Row>
                                  <Col md={10}>
                                    <strong>{props.notificationsDetails.details}</strong>
                                  </Col>
                                  <Col md={2} className="text-end">
                                    <Button
                                      close
                                      onClick={() => props.setNotificationsDetails({
                                        tabs: 2,
                                        details: '',
                                        action: false,
                                        searchparams: ''

                                      })}
                                      className="close-button"
                                    />
                                  </Col>
                                </Row>
                              </Card>
                              : ''} */}
                          </>

                    
                        {!props.isMyworksScreen && (
                        <Col md={5} className=''>
                          <p className="text-center"><b>TICKET AGE COLORING</b></p>
                          <div className="row justify-content-center">
                            {
                              Object.values(ticketAgeColor).map((ticket) => {
                                return (
                                  <div className="col-3">
                                    {statusColorDecription.map((item) => (
                                      item.colourCode === ticket ? <p onClick={() => ViewTicketAgeDiscription(item.id, item.ticketAgeDays, item.colourCode)} className="text-center p-2 mb-0" style={{ backgroundColor: item.colourCode }}>
                                        <b>{item.ticketAgeDays} days</b>
                                      </p> : ''
                                    ))}
                                  </div>
                                );
                              })
                            }
                          </div>

                          {/* </div> */}
                        </Col> 
                        )}
                      </Row>
                      <span className="mb-2 mt-4" style={{ marginLeft: "0px" }}>
                        <input
                          type="radio"
                          name="statusFilter"
                          value={statusFilter}
                          checked={statusFilter === "All"}
                          className="ml-2"
                          onChange={() => {
                            setStatusFilter("All");
                            setAssignedToFilter(false)
                          }}
                        />
                        &nbsp;
                        <b>All</b>
                      </span>
                      <span className="mb-2" style={{ marginLeft: "30px" }}>
                        <input
                          type="radio"
                          name="statusFilter"
                          value={statusFilter}
                          checked={statusFilter === "Open"}
                          className="ml-2 mt-2 mb-3"
                          onChange={() => {
                            setStatusFilter("Open");
                            setAssignedToFilter(false)
                          }}
                        />
                        &nbsp;
                        <b>Open</b>
                      </span>

                      {ticketStatuslist
                        ? ticketStatuslist.map((status) => (
                          <span className="mb-2" style={{ marginLeft: "30px" }}>
                            <input
                              type="radio"
                              name="statusFilter"
                              value={status.ticketStatus}
                              checked={statusFilter === status.ticketStatus}
                              className="ml-2 mt-2 mb-3"
                              onChange={() => {
                                setStatusFilter(status.ticketStatus);
                                setAssignedToFilter(false)
                              }
                              }
                            />
                            &nbsp;
                            <b>{status.ticketStatus}</b>

                          </span>
                        ))
                        : ""}
                      <ReactTable
                        data={filteredTicketList}
                        columns={filteredColumns}
                        getTrProps={getRowProps}
                        getTdProps={(state, rowInfo, column, instance) => {

                          // Check if the current cell belongs to the first column
                          //  && rowInfo.original.priority === "Internal Ticket"
                          if (column.id === "priority" || column.id === 'ticketId') {
                            if (rowInfo && rowInfo.original.priority === "Internal Ticket") {
                              return {
                                style: {
                                  backgroundColor: '#f7ddee', // Set pink background color for ID 10
                                  // Add any other styles you need
                                },
                              };
                            }
                          }
                          if (column.id === "priority" || column.id === 'ticketId') {
                            if (rowInfo && rowInfo.original.priority === "Onboarding Task") {
                              return {
                                style: {
                                  backgroundColor: '#96e0e5',
                                },
                              };
                            }
                          }
                          return {
                            // style: {
                            //   backgroundColor: '#000000', 
                            // },
                          };
                        }}
                        className="-fixed -highlight -striped"
                        getTheadProps={() => {
                          return {
                            style: {
                              overflowY: "hidden",
                              background: "#B1FA63",
                              color: "#243837",
                            },
                          };
                        }}
                        defaultPageSize={ 25}
                        noDataText={"No Data Found."}
                      />
                    </>}
                </CardBody>
              </Card>
            </Col>
            ) : (
              <Col md={12} className='mt-5'>
                <LoadingOverlay
                  active={!ticketStatuslistCount}
                  styles={{
                    overlay: (base) => ({
                      ...base,
                      background: '#f1f4f6',
                      opacity: 1,
                    }),
                    content: (base) => ({
                      ...base,
                      color: '#000',
                    }),
                  }}
                  spinner={<Loader active type="ball-pulse" />}
                  text='Loading Your Ticket List...'
                />
              </Col>
            )}
        </Row>
      </Container>

      <CustomModal
        header={
          <div>
            <p className="mb-0">
              {storeNameForViewTicket}
            </p>
            <p className="mb-0 d-flex justify-content-between">
              <div className="d-flex">
                <span><b>Ticket Id :</b> {ticketId}</span>
                <span className="ml-3">{problemArea ? problemArea : ''}</span>
                <span className="ml-3">
                  <FontAwesomeIcon icon={faArrowRight} />
                </span>
                <span className="ml-3">{problemAreaPathway ? problemAreaPathway : ''}</span>
              </div>
              <span className="ml-3">
                {storeDateTimeForViewTicket}
              </span>
            </p>
          </div>

        }
        isOpen={isViewTicketOpen}
        toggle={() => setIsViewTicketOpen(!isViewTicketOpen)}
        size={"xl"}
        className="bgColor"

      >
        <PMPartnerViewTicket
          isFromCreatingTicket={false}
          ticketId={ticketId}
          ticketList={ticketList}
          ticketStatuslist={ticketStatuslist}
          mainRequestTypes={mainRequestTypes}
          subRequestTypes={subRequestTypes}
          ticketViewData={ticketViewData}
          handleCreateAndViewTicketClose={handleCreateAndViewTicketClose}
          handleAmazonCasePopup={handleAmazonCasePopup}
          problemAreaPathwayList={problemAreaPathwayList}
          problemAreaList={problemAreaList}
          problemAreaId={props.problemAreaId}
          problemAreaPathwayId={props.problemAreaPathwayId}
          storeIdForViewTicket={storeIdForViewTicket}
          storeNameForViewTicket={storeNameForViewTicket}
          storeDateTimeForViewTicket={storeDateTimeForViewTicket}
          amazonCaseId={amazonCaseId}
          amazonCaseUrl={amazonCaseUrl}
          permissions={permissions}
        />
      </CustomModal>
      <CustomModal
        header={
          <div>
            <p className="mb-0">
              {storeNameForViewTicket}
            </p>
            <p className="mb-0 d-flex justify-content-between">
              <div className="d-flex">
                <span><b>Ticket Id :</b> {ticketId}</span>
                <span className="ml-3">{problemArea ? problemArea : ''}</span>
                <span className="ml-3">
                  <FontAwesomeIcon icon={faArrowRight} />
                </span>
                <span className="ml-3">{problemAreaPathway ? problemAreaPathway : ''}</span>
              </div>
              <span className="ml-3">
                {storeDateTimeForViewTicket}
              </span>
            </p>
          </div>
        }

        isOpen={isSWViewTicketOpen}
        toggle={() => setIsSWViewTicketOpen(!isSWViewTicketOpen)}
        size={"xl"}
        className="bgColor"
      >
        <PMSWViewTicket
          ticketId={ticketId}
          isFromCreatingTicket={false}
          ticketList={ticketList}
          teamMembers={teamMembers}
          ticketStatuslist={ticketStatuslist}
          createrPriority={createrPriority}
          mainRequestTypes={mainRequestTypes}
          subRequestTypes={subRequestTypes}
          ticketViewData={ticketViewData}
          handleAmazonCasePopup={handleAmazonCasePopup}
          handleCreateAndViewTicketClose={handleCreateAndViewTicketClose}
          problemAreaPathwayList={problemAreaPathwayList}
          problemAreaList={problemAreaList}
          problemAreaId={props.problemAreaId}
          problemAreaPathwayId={props.problemAreaPathwayId}
          storeIdForViewTicket={storeIdForViewTicket}
          storeNameForViewTicket={storeNameForViewTicket}
          storeDateTimeForViewTicket={storeDateTimeForViewTicket}
          isInternalTicketCheck={isInternalTicketCheck}
          amazonCaseId={amazonCaseId}
          amazonCaseUrl={amazonCaseUrl}
          permissions={permissions}
        />
      </CustomModal>
      <CustomModal
        header={
          <div>
            <p className="mb-0">
              {storeNameForViewTicket}
            </p>
            <p className="mb-0 d-flex justify-content-between">
              <div className="d-flex">
                <span><b>Ticket Id :</b> {ticketId}</span>
                <span className="ml-3">{problemArea ? problemArea : ''}</span>
                <span className="ml-3">
                  <FontAwesomeIcon icon={faArrowRight} />
                </span>
                <span className="ml-3">{problemAreaPathway ? problemAreaPathway : ''}</span>
              </div>
              <span className="ml-3">
                {storeDateTimeForViewTicket}
              </span>
            </p>
          </div>
        }

        isOpen={isAgencyTicketPopup}
        toggle={() => setIsAgencyTicketPopup(!isAgencyTicketPopup)}
        size={"xl"}
        className="bgColor"
      >
        <PMAgencyViewTicket
          ticketId={ticketId}
          isFromCreatingTicket={false}
          ticketList={ticketList}
          teamMembers={teamMembers}
          ticketStatuslist={ticketStatuslist}
          mainRequestTypes={mainRequestTypes}
          subRequestTypes={subRequestTypes}
          ticketViewData={ticketViewData}
          handleAmazonCasePopup={handleAmazonCasePopup}
          setIsAgencyTicketPopup={setIsAgencyTicketPopup}
          handleCreateAndViewTicketClose={handleCreateAndViewTicketClose}
          problemAreaPathwayList={problemAreaPathwayList}
          problemAreaList={problemAreaList}
          problemAreaId={props.problemAreaId}
          problemAreaPathwayId={props.problemAreaPathwayId}
          storeIdForViewTicket={storeIdForViewTicket}
          storeNameForViewTicket={storeNameForViewTicket}
          storeDateTimeForViewTicket={storeDateTimeForViewTicket}
          isInternalTicketCheck={isInternalTicketCheck}
          amazonCaseId={amazonCaseId}
          amazonCaseUrl={amazonCaseUrl}
          permissions={permissions}
        />
      </CustomModal>
      <CustomModal
        header={"Issue Description"}
        isOpen={issueDescription}
        toggle={() => setIssueDescription(!issueDescription)}
        size={"lg"}
        className='curve-popup'
        footer={
          <>
            <Button
              color={"link"}
              onClick={() => setIssueDescription(!issueDescription)}
            >
              Cancel
            </Button>
          </>
        }
      >
        <Label>
          <p className="issue-discription-set">
          {/* <p>{issueDescriptionText}</p> */}
          <PMSmartDataFormatter 
                    data={replaceIssueDescriptionText} 
                    maxLength={200} 
                  />
                  </p>
        </Label>
      </CustomModal>
      <CustomModal
        header={"ASIN List"}
        isOpen={showAsin}
        toggle={() => setShowAsin(!showAsin)}
        size={"md"}
        className='curve-popup'
        footer={
          <>
            <Button
              color={"link"}
              onClick={() => setShowAsin(!showAsin)}
            >
              Cancel
            </Button>
          </>
        }
      >
        <Label>
          <ul>
            {allAsinList && allAsinList.map((asin, index) => (
              <li key={index}>{asin}</li>
            ))}
          </ul>
        </Label>
      </CustomModal>
      <CustomModal
        header={"Update"}
        isOpen={ticketAgeDaysIsOpen}
        toggle={() => setTicketAgeDaysIsOpen(!ticketAgeDaysIsOpen)}
        size="sm"
        className='card-of-problemarea bgColor '
      >
        <Card className='p-0 card-of-problemarea  ' >
          <Container >
            <div className=" p-0">
              <div className="">
                <div className="text-center mx-auto mb-3">
                </div>

                <Form>
                  <Row form className='pt-1 pl-2 pr-2 pb-3'>
                    <Col md={12}>
                      <Label>
                        <div className="d-flex justify-content-center"><h6 className=" text-white p-2" style={{ backgroundColor: ticketAgeDaysColor }}>Ticket Age Days :</h6> <input className="form-control w-25 ml-3" value={ticketAgeDays} onChange={(e) => setTicketAgeDays(e.target.value)} /> </div>
                        <p className="text-center  mb-0 mt-3"><Button className="btn_class" onClick={() => UpdateTicketAgeDays(ticketAgeId)}>Submit</Button></p>
                      </Label>
                    </Col>

                  </Row>
                </Form>
              </div>
            </div>
          </Container>
        </Card>
      </CustomModal>
    </section>
  );
}
const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    globalPermissions: state.loggedUser.globalPermissions,
    status: state.loggedUser.status,
    error: state.loggedUser.error,
    stores: state.accountOverview.landing.adProfiles,
    storeOverview: state.accountOverview.store.storeOverview,
    storeProducts: state.accountOverview.store.storeProducts,
    newUser: state.loggedUser.newUser,
    needsAdvertisingAPIAuth: state.loggedUser.needsAdvertisingAPIAuth,
    user: state.LWA.user,
    isAuth: state.LWA.isAuth,
    enableMobileMenu: state.theme.enableMobileMenu,
    enableClosedSidebar: state.theme.enableClosedSidebar,
  };
};

export default connect(mapStateToProps)(ProactiveTicketMainPage);
